import { validDDDs } from 'common/schema/const';
import { isValidCPF } from 'common/schema/validatedCpf';
import * as yup from 'yup';

export const personalData = yup.object().shape({
  email: yup
  .string()
  .email('Informe um email válido')
  .matches(/^[^\s@]+@[^\s@]+\.(com(\.br)?|br)$/,'Informe um email válido')
  .required('Informe um email válido')
  .trim(),

  phoneNumber: yup
  .string()
  .required('Informe o número')
  .test('valid-ddd', 'DDD inválido', (value) => {
    if (!value) return false;
    const numbers = value.replace(/\D/g, '');
    const ddd = numbers.substring(0, 2);
    return validDDDs.includes(ddd);
  })
  .test('no-repeated-numbers','Número de telefone inválido',
    (value) => {
      if (!value) return false;
      const numbers = value.replace(/\D/g, '');
      const phoneWithoutDDD = numbers.substring(2);
      return !/^(\d)\1+$/.test(phoneWithoutDDD);
    })
  .matches(/^\(\d{2}\)\s\d{5}-\d{4}$/,'Informe um número de telefone válido')
  .trim(),

  marketing: yup.boolean(),

  terms: yup.boolean().required().oneOf([true], 'Você precisa aceitar os termos de uso'),
});

export const morePersonalData = yup.object().shape({
  cpf: yup
    .string()
    .required('Informe o CPF')
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'Informe um CPF válido no formato 000.000.000-00')
    .test(
      'valid-cpf',
      'Informe um CPF válido',
      (value) => {
        if (!value) return false;
        return isValidCPF(value);
      }
    ),

  name: yup
    .string()
    .required('Informe o nome completo')
    .min(3, 'Nome muito curto')
    .matches(/^[A-Za-zÀ-ÿ]+(\s[A-Za-zÀ-ÿ]+)+$/, 'Informe o nome completo')
    .trim(),

  monthlyIncome: yup
    .string()
    .required('Informe a renda mensal')
    .transform((value) => {
      if (!value) return '';
      return value.replace(/\D/g, '').replace(/(\d{2})$/, '.$1');
    })
    .test('is-positive', 'A renda deve ser maior que zero', (value) => Number(value) > 0),
});
